"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isPromise(subject) {
    return !!subject && typeof subject.then === 'function';
}
exports.isPromise = isPromise;
//# sourceMappingURL=isPromise.js.map